/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Inbounds_To_ResolveInputs */

const en_queue_inbounds_to_resolve = /** @type {(inputs: Queue_Inbounds_To_ResolveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Received inbounds to confirm`)
};

/**
* | output |
* | --- |
* | "Received inbounds to confirm" |
*
* @param {Queue_Inbounds_To_ResolveInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_inbounds_to_resolve = /** @type {((inputs?: Queue_Inbounds_To_ResolveInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Inbounds_To_ResolveInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_inbounds_to_resolve(inputs)
});